export default {
  reset: {
    border: 'none',
    margin: 0,
    padding: 0,
    width: 'auto',
    overflow: 'visible',
    background: 'transparent',
    lineHeight: 'normal'
  }
}
